<template>
  <md-toolbar
      md-elevation="0"
      class="md-transparent"
      :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>

      <div class="md-toolbar-section-end">
        <!-- Sidebar toggle -->
        <md-button
            class="md-just-icon md-round md-simple md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <!-- Dashboard -->
            <md-list-item href="#/">
              <i class="material-icons">dashboard</i>
            </md-list-item>

            <!-- Notifications -->
            <li class="md-list-item">
              <div class="md-list-item-content">

                <drop-down direction="down" @click="openNotifications">
                  <md-button slot="title" class="md-button md-just-icon md-simple">
                    <md-icon>notifications</md-icon>

                    <!-- COUNT ONLY -->
                    <span v-if="notificationCount > 0" class="notification">
                      {{ notificationCount }}
                    </span>
                  </md-button>

                  <ul class="dropdown-menu dropdown-menu-right">

                    <li v-if="loading" class="px-3 py-2">
                      Loading...
                    </li>

                    <li
                        v-for="n in notifications.slice(0, 5)"
                        :key="n.guidance_id"
                    >
                      <a @click="openNotification(n)">
                        {{ n.title }}
                      </a>
                    </li>

                    <li class="dropdown-divider"></li>

                    <li>
                      <a @click="goToNotifications">
                        View All Notifications
                      </a>
                    </li>

                  </ul>
                </drop-down>

              </div>
            </li>

            <!-- Profile -->
            <md-list-item @click="goToUsers">
              <i class="material-icons">person</i>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import Vuex from "vuex";

export default {
  data() {
    return {
      dropdownLoaded: false
    };
  },

  computed: {
    ...Vuex.mapGetters({
      notificationCount: 'notifications/count',
      notifications: 'notifications/items',
      loading: 'notifications/loading'
    })
  },

  created() {
    this.loadCount();

    // ONLY COUNT polling (lightweight)
    this.notificationInterval = setInterval(() => {
      this.loadCount();
    }, 120000);
  },

  beforeDestroy() {
    clearInterval(this.notificationInterval);
  },

  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },

    goToNotifications() {
      if (this.$route.name !== 'Notifications') {
        this.$router.push({ name: 'Notifications' });
      }
    },

    goToUsers() {
      this.$router.push({ name: 'User Profile' });
    },

    openNotification(n) {
      if (n.guidance_id) {
        this.$router.push({
          name: 'View Guidance',
          params: { id: n.guidance_id }
        });
      }
    },

    loadCount() {
      this.$store.dispatch('notifications/count');
    },

    async openNotifications() {
      // Lazy load ONLY once per session
      if (!this.dropdownLoaded) {
        await this.$store.dispatch('notifications/pending');
        this.dropdownLoaded = true;
      }
    }
  }
};
</script>
